(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["espoirvia-rutina"] && !Shopify.designMode) return;
  try {
    

function initEspoirviaRituals(root) {

  if (!root || root.dataset.evReady === 'true') return;

  root.dataset.evReady = 'true';

  const buttons = root.querySelectorAll('[data-ev-tab]');
  const panels = root.querySelectorAll('[data-ev-panel]');

  buttons.forEach((button) => {

    button.addEventListener('click', () => {

      const target = button.dataset.evTab;
      const isAlreadyOpen = button.classList.contains('is-active');

      /* Cerrar todo */
      buttons.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-expanded', 'false');
      });

      panels.forEach((panel) => {
        panel.classList.remove('is-active');
      });

      /* Si tocó el mismo, queda cerrado */
      if (isAlreadyOpen) return;

      /* Abrir seleccionado */
      button.classList.add('is-active');
      button.setAttribute('aria-expanded', 'true');

      const selectedPanel = root.querySelector(
        '[data-ev-panel="' + target + '"]'
      );

      if (selectedPanel) {
        selectedPanel.classList.add('is-active');
      }

    });

  });

}


function initAllEspoirviaRituals(scope = document) {

  scope
    .querySelectorAll('.ev-rituals')
    .forEach(initEspoirviaRituals);

}


document.addEventListener('DOMContentLoaded', () => {
  initAllEspoirviaRituals();
});


document.addEventListener('shopify:section:load', (event) => {
  initAllEspoirviaRituals(event.target);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
